/**
* this file contains all reusable utility functions
*
* Created by Tom on 24/7/17
*/

import moment from 'moment'

/**
 * requests a URL, returning a promise
 *
 * @param  {string} url - the URL we want to request
 * @param  {object} [options] - the options we want to pass to "fetch"
 * @return {object} - an object containing either "data" or "err"
 */
export const request = (url, options) => {
    return fetch(url, options)
        // .then(<check the status>) TODO: strategy to check status 404, 300, 200 etc
        .then(response => {
            if(!response.ok) {
                throw new Error(response.status)
            } else {
                return response.json()
            }
        })
        .then(data => ({ data }))
        .catch(err => ({ err }))
}

// checks if an object is empty
export const isEmpty = (obj) => {
    let res = true;
    for (let prop in obj) {
        if (! obj.hasOwnProperty(prop)) { continue }
        const type = typeof obj[prop]
        switch (type){
            case "object": res = isEmpty(obj[prop])
                break
            case "boolean":
            case "number": res = false // boolean cannot be "empty", also 0 is not empty
                break
            case "string": res = ! obj[prop].length
                break
            case "undefined": res = true
                break
            default: res = !! obj[prop];
                break
        }
        if (!res) {break}
    }
    return res
}

// mock the API call delay
export const wait = ms => new Promise(resolve => setTimeout(resolve, ms))

// check if string has the following conditions:
// - must be between 8 - 16 characters long and
// - must have 2 capital letter or
// 2 numbers or
// 2 special characters e.g. !#.$
export const checkPass = stringData => {
    return /^(?=.*[a-z])(?=(.*[A-Z]){2,}|(.*\d){2,}|(.*[!@#$%^&*(){}[\]:“?<>]){2,}).{8,16}$/g.test(stringData)
}

// converts UTC to local time and formats the time like 01/01/2017
export const formatDateText = (utcDate) => {
    return (utcDate) ? moment.utc(utcDate).local().format('DD/MM/YYYY') : ''
}



/*
* this function converts a number into a international currency format
* i.e. 23456 becomes $23,456
* @param - locale (STRING) - i.e. 'en-US', 'en-GB', 'en-AU'
* @param - style (STRING) - i.e. 'currency'
* @param - currency (STRING) - i.e. 'USD', 'AUD'
* @param - number (STRING or INTEGER) - the number to be formatted
*/
export const intlNumberFormatter = (locale, style, currency, number) => {
    // return nothing if there is no number
    if(!number) return ''
    const localeString = (locale) ? locale : 'en-US'
    // create a Intl.NumberFormat object
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat
    var formatter = new Intl.NumberFormat(localeString, {
        style: (style) ? style : 'currency',
        currency: (currency) ? currency : 'AUD',
        minimumFractionDigits: 2
    })
    // format and return the currency formatted value
    return formatter.format(number)
}



// WEBPACK FOOTER //
// ./src/utility/utilities.js